import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFinAjeerData } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";
import FinListAjeer from "./FinListAjeer";

export default function FinAjeer() {
  const ajeer = useSelector((state) => state.finAjeer);

  //screen Title Show fun
  const titleBorder = [{ label: "Ajeer", link: "/dashboard/Ajeer" }];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getFinAjeerData(token));
  }, []);

  const updateData = () => {
    dispatch(getFinAjeerData(token));
  };

  return (
    <div className={`ml-5 mr-5`}>
      <FinListAjeer
        titles={[
          "SR.NO.",
          "employee ID",
          "employee NAME",
          "SPONSOR",
          "client",
          "visa Provider",
          "IQAMA NUMBER",
          "AJEER LOCATION ENGLISH",
          "AJEER LOCATION ARABIC",
          "AJEER APPLY DATE",
          "AJEER ISSUE DATE",
          "AJEER EXPIRE DATE",
          "AJEER VALID DAYS",
          "Status",
          "ACTION",
        ]}
        list={ajeer}
        loading={loading}
        token={token}
        updateData={updateData}
      />
    </div>
  );
}
